import { asiatique } from "./asiatique"
import { loveEat } from "./love-eat"
import { touristFriendly } from "./tourist-friendly"

export const extensionConfigs = {
  asiatique: asiatique,
  "love-eat": loveEat,
  "tourist-friendly": touristFriendly,
}
